import React, { Component } from 'react'
import { Link, Redirect, withRouter } from 'react-router-dom'
import { notify } from 'react-notify-toast'
import Spinner from './Spinner'
import { API_URL } from '../config'

import { Container, Confirm as ConfirmSemantic,   Grid, Image,  Header, Button,  } from 'semantic-ui-react'
// import { Consumer, MyContext } from '../../../../../context/Context'
import axios from 'axios'


class Confirm extends Component {

  // A bit of state to give the user feedback while their email
  // address is being confirmed on the User model on the server.

  // state = {
  //   confirming: true,
  //   open: false, 
  //   result: 'show the modal to capture a result',
  // }

  
  
  state = {
    // confirming: true,
    //  id  : this.props.match.params,
    msg: '',
    oname: '',
    open: false, 
    result: 'Would you like to join this group?',
    hide: false,
  }

  // state = { open: false, result: 'show the modal to capture a result' }

  show = () => this.setState({ open: true })



   client = axios.create({
    baseURL: 'http://localhost:3000',
    json: true
  })
  
  confirmPost = () =>{
    const token = localStorage.getItem('token');
    const localId = localStorage.getItem('userId');
    const { id } = this.props.match.params
    // fetch(`${API_URL}/email/confirm/:id'`, {
    //   method: 'pOSt',
    //   headers: {
    //     aCcePt: 'aPpliCaTIon/JsOn', 
    //     'cOntENt-type': 'applicAtion/JSoN'
    //   },
    //   body: JSON.stringify({
    //      uid: localId,
    //    })

    
    // })
    
    this.client({
      method: 'post',
      // url: `${API_URL}/email/confirm/id=5e33a147347f3171585789ad&token=sdfa3&geo=us&uid=${localId}`,
      url: `${API_URL}/email/confirm/${id}`,
      headers: {
        'AuthToken': token
      },
      data: {
        uid: localId,
      }
    }).then((res) => {
      console.log(res)
      this.setState({
        msg: res.data.msg,

      })
    })

 

    // fetch(`${API_URL}/email/confirm/${id}`, {
    //   method: 'pOSt',
    //   headers: {
    //     aCcePt: 'aPpliCaTIon/JsOn', 
    //     'cOntENt-type': 'applicAtion/JSoN'
    //   },
    //   body: JSON.stringify({
    //      'uid': localId,
    //    })
    // })
    // .then(res => res.json())  
    // .then(data => {
    //   console.log(data)
    //   // Everything has come back successfully, time to update the state to 
    //   // reenable the button and stop the <Spinner>. Also, show a toast with a 
    //   // message from the server to give the user feedback and reset the form 
    //   // so the user can start over if she chooses.
    //   // this.setState({ sendingEmail: false})
    //   // notify.show(data.msg)
    //   // this.form.reset()
    // })
    // .catch(err => console.log(err))
  
    this.props.history.push(this.props.location.pathname)
}



  confirmFetch = () => {
  // const id = this.props.match.params.id
  // console.log(this.state.id)
  const { id } = this.props.match.params
  const token = localStorage.getItem('token');

  // mailgun approach
    this.client({
      method: 'get',
      url: `${API_URL}/email/confirm/${id}`,
      headers: {
        'AuthToken': token
      }
    }).then((res) => {
      console.log(res)
      this.setState({
        oname: res.data.oname,
        msg: res.data.msg
      })

      if(res.data.msg === 'Ask the Administrator to invite you with a new invite link!' || res.data.msg === 'Your email was already confirmed'){
        this.setState({hide: true})
      }

      this.response = res.data.message
    }).catch((error) => {
      this.response = error
    })

// google email approach
      // fetch(`${API_URL}/email/confirm/${id}`)
      // .then((res) =>{
      //   // console.log(res)
      //     res.json()
      //   })
      // .then(data => {
      //   this.setState({ confirming: false })
      //   notify.show(data.msg)
      // })
      // .catch(err => console.log(err))
    return(
      <div>
        <Header>confirmfetch function</Header>

      </div>
    )
  }
  handleConfirm = () => 
  {
    // this.confirmFetch()
    this.confirmPost()
  
  this.setState({ result: 'confirmed', open: false })
  }

  handleCancel = () => this.setState({ result: 'cancelled', open: false })



  // When the component mounts the mongo id for the user is pulled  from the 
  // params in React Router. This id is then sent to the server to confirm that 
  // the user has clicked on the link in the email. The link in the email will 
  // look something like this: 
  // 
  // http://localhost:3000/confirm/5c40d7607d259400989a9d42
  // 
  // where 5c40d...a9d42 is the unique id created by Mongo
  componentDidMount = () => {

    const expDate = new Date(localStorage.getItem('expDate'));

    const token = localStorage.getItem('token');
    const localId = localStorage.getItem('userId');

    this.confirmFetch()
    // if (expDate < new Date()) {
    //   this.context.dispatch({
    //     type: 'AUTH_LOGOUT',
    //     payload: { token: null, localId: null }
    //   });
    // }


    // const tk = localStorage.getItem('token');
    // if (!tk) {
    //   this.context.dispatch({
    //     type: 'AUTH_LOGOUT',
    //     payload: { token: null, localId: null }
    //   });
    // } else {
    //   const expDate = new Date(localStorage.getItem('expDate'));
    //   if (expDate < new Date()) {
    //     this.context.dispatch({
    //       type: 'AUTH_LOGOUT',
    //       payload: { token: null, localId: null }
    //     });
    //   } else {
    //     const localId = localStorage.getItem('userId');
    //     this.context.dispatch({
    //       type: 'AUTH_LOGIN',
    //       payload: { token: tk, localId: localId }
    //     });
    //   }
    // }





    const { id } = this.props.match.params
    console.log(this.props)

    // console.log(token)
    // console.log(this.state.confirming)

    // const expDate = new Date(localStorage.getItem('expDate'));


    if (expDate < new Date()) {
      localStorage['token'] =''
        return (
          this.props.history.push("/login")
        )
      }


    // if (!token) {
    //   return (
    //     this.props.history.push("/")
    //   )
    // }
    else {
      // this.setState({confirming:false})
      // this.setState({ confirming: false })
    }
    // console.log(this.state.confirming)

    // if (false){
    //   return(
    //     // <Redirect to="/"/>
    //     this.props.history.push("/") 
    //   )
    // }

    // fetch(`${API_URL}/email/confirm/${id}`)
    //   .then(res => res.json())
    //   .then(data => {
    //     this.setState({ confirming: false })
    //     notify.show(data.msg)
    //   })
    //   .catch(err => console.log(err))
  }

  // While the email address is being confirmed on the server a spinner is 
  // shown that gives visual feedback. Once the email has been confirmed the 
  // spinner is stopped and turned into a button that takes the user back to the 
  // <Landing > component so they can confirm another email address.
  render() {
    const { open, result } = this.state
    return (
      // <div >
      <div className='confirm'>
        {/* {this.state.confirming
          ? <Spinner size='8x' spinning={'spinning'} />
          : <Link to='/'>
            <Spinner size='8x' spinning={''} />
          </Link>
        } */}

        {/* {console.log(this.state.confirming)} */}
       
       {/* <Header> {'' || this.state.msg}</Header> */}
          <Grid>
            <Grid.Column>
              <Header as='h1'  >
                {/* <Icon name='user' /> */}
                <Image src={'avatar'} />
                <Header.Content>
                  {/* <Header.Subheader> <b>Organization</b></Header.Subheader> */}
                  {'' || this.state.oname}
                </Header.Content>
              </Header>
            </Grid.Column>
          </Grid>
          
           
        {/* <h4><em>{result}</em></h4> */}

        <Header> {this.state.msg || result}</Header>
         
        {/* { this.state.hide ||(<Button onClick={this.show}>Confirm</Button>) } */}

        <Button onClick={this.show}>Confirm</Button>
        
        <ConfirmSemantic open={this.state.open} onCancel={this.handleCancel} onConfirm={this.handleConfirm} />

    
      </div>
    )

  }
}


// Confirm.contextType = MyContext;
  export default Confirm;